import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, LoadingSkeleton } from "@/components/shared/States";
import { BarChart3 } from "lucide-react";
import { fmtMoney } from "@/lib/format";
import { BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const COLORS = ["#7C3AED", "#3B82F6", "#06B6D4", "#10B981", "#A855F7", "#F59E0B", "#EF4444"];

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics").then(({ data }) => setD(data)); }, []);
  if (!d) return <LoadingSkeleton />;

  const KPI = ({ label, value }) => (<div className="rounded-2xl bg-white border border-slate-200 p-4"><div className="text-xs text-slate-500">{label}</div><div className="text-2xl font-bold tabular-nums mt-1">{value}</div></div>);

  return (
    <div>
      <PageHeader title="Analytics" subtitle="Revenue performance at a glance" icon={BarChart3} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <KPI label="Open Pipeline" value={fmtMoney(d.pipeline)} />
        <KPI label="Weighted Pipeline" value={fmtMoney(d.weighted)} />
        <KPI label="Win Rate" value={`${d.win_rate}%`} />
        <KPI label="Avg Deal Size" value={fmtMoney(d.avg_deal)} />
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="rounded-2xl bg-white border border-slate-200 p-5">
          <h3 className="text-sm font-semibold text-slate-900 mb-4">Pipeline by Stage</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={d.stage_distribution}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="stage" tick={{ fontSize: 11 }} interval={0} angle={-20} textAnchor="end" height={60} /><YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} /><Tooltip formatter={(v) => fmtMoney(v)} /><Bar dataKey="value" radius={[6, 6, 0, 0]} fill="#7C3AED" /></BarChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-2xl bg-white border border-slate-200 p-5">
          <h3 className="text-sm font-semibold text-slate-900 mb-4">Lead Sources</h3>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart><Pie data={d.lead_sources} dataKey="count" nameKey="source" cx="50%" cy="50%" outerRadius={100} label={(e) => e.source}>{d.lead_sources.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Tooltip /></PieChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="rounded-2xl bg-white border border-slate-200 p-5 mt-4">
        <h3 className="text-sm font-semibold text-slate-900 mb-4">Forecast</h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {[["Pipeline", d.forecast.pipeline], ["Weighted", d.forecast.weighted], ["Commit", d.forecast.commit], ["Best Case", d.forecast.best_case]].map(([l, v]) => (
            <div key={l} className="rounded-xl bg-slate-50 p-4"><div className="text-xs text-slate-500">{l}</div><div className="text-xl font-bold tabular-nums mt-1">{fmtMoney(v)}</div></div>
          ))}
        </div>
      </div>
    </div>
  );
}
